import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import DiamondSopoLogo from '../assets/icons/logo-small.png';
import SopoLogo from '../assets/icons/sopoLogo.png';
import Hamburger from '../assets/icons/hamburger.png';
import AppStore from '../assets/icons/app-store.png';
import GooglePlay from '../assets/icons/google-play.png';

const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'HOW TO PLAY', path: 'howtoplay' },
    { name: 'WEB3', path: 'web3integration' },
    { name: 'FEATURES', path: 'socialfeatures' },
    { name: 'CERTIFICATIONS', path: 'certifiedfair' },
    { name: 'CONTACT', path: 'contact-us' },
];

const Navbar = ({ onOpenPopup }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [headerColor, setHeaderColor] = useState("transparent");
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth <= 1025);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            setHeaderColor(window.scrollY > 0 ? '#001736' : 'transparent');
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMenuOpen(false);
        window.scrollTo(0, 0);
    }, [location]);

    const handleNavigate = (path) => {
        setIsMenuOpen(false);
        navigate(path);
    };

    const handleOpenPopup = () => {
        onOpenPopup();
        setIsMenuOpen(false);
    };

    const renderNavLinks = () => (
        <>
            {navLinks.map((link) => (
                <li key={link.path} className="items" onClick={() => handleNavigate(link.path)}>
                    {link.name}
                </li>
            ))}
        </>
    );

    const renderStoreButtons = () => (
        <div className="navbar-store-icons">
            <img onClick={() => window.open(process.env.REACT_APP_IOS_STORE_URL)} src={AppStore} alt="store-icons" />
            <img onClick={() => window.open(process.env.REACT_APP_ANDROID_STORE_URL)} src={GooglePlay} alt="google-play-icons" />
        </div>
    );

    const isStoreButtonsVisible = location.pathname !== '/';

    const DesktopNavbar = () => (
        <div className="left-align-div">
            <ul className="list">
                <li className="items navbar-logo">
                    <img src={DiamondSopoLogo} alt="diamond-logo" />
                </li>
                {renderNavLinks()}
            </ul>
            {isStoreButtonsVisible ? renderStoreButtons() : <div className="navbar-button" onClick={onOpenPopup}>Postal Request</div>}
        </div>
    );

    const MobileNavbar = () => (
        <>
            <div className="mobile-top-bar">
                <div className="m-li-div">
                    <li className="items-mobile">
                        <img style={{ maxWidth: '45px' }} src={DiamondSopoLogo} onClick={() => navigate('/')} alt="sopoLogo" />
                    </li>
                </div>
                <div className="m-li-div">
                    <img src={SopoLogo} alt="sopoLogo" />
                </div>
                <div className="m-li-div j-start">
                    <li className="items-mobile" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <img src={Hamburger} style={{ maxWidth: '31px' }} alt="hamburgerMenu" />
                    </li>
                </div>
            </div>
            <div className={` ${isMenuOpen ? 'toggleMenu' : 'mobile-nav-container'} `}>
                <ul>
                    {renderNavLinks()}
                    <div className="navbar-button" onClick={handleOpenPopup}>Postal Request</div>
                    {renderStoreButtons()}
                </ul>
            </div>
        </>
    );

    return (
        <>
            {screenWidth > 1025 ? (
                <nav style={{ background: headerColor }}>
                    <div className="wide-container d-flex j-center nav-inner">
                        <DesktopNavbar />
                    </div>
                </nav>
            ) : (
                <MobileNavbar />
            )}
        </>
    );
};

export default Navbar;